import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack } from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Choose the Right Cleaner',
    description: 'Use all-purpose cleaner for most surfaces, but opt for specialty products for glass, wood, or stone.',
  },
  {
    title: 'Read Labels Carefully',
    description: 'Always follow manufacturer instructions for safe and effective use of cleaning products.',
  },
  {
    title: 'Store Safely',
    description: 'Keep cleaning products out of reach of children and pets, and store in a cool, dry place.',
  },
  {
    title: 'Pro Tip: DIY Solutions',
    description: 'Mix vinegar and water for a natural glass cleaner, or baking soda and water for a gentle scrub.',
    pro: true,
  },
  {
    title: "Don't Mix Chemicals",
    description: 'Never mix bleach with ammonia or other cleaners—dangerous fumes can result.',
  },
  {
    title: 'Use Microfiber Cloths',
    description: 'Microfiber cloths trap dust and clean surfaces without scratching or leaving lint.',
  },{
    title: 'pH-Match Your Chore',
    description: 'Use alkaline cleaners (pH > 8) for grease; acidic ones (pH < 6) for mineral deposits. This targeted approach reduces scrubbing time dramatically.',
  },
  {
    title: 'Enzymatic Power Plays',
    description: 'Stock an enzyme-based spray—these biological agents digest organic stains (blood, wine, pet accidents) at a molecular level, not just mask odors.',
  },
  {
    title: 'Dilution Discipline',
    description: 'Always measure cleaning concentrates precisely. Over-diluting wastes product; under-diluting leaves residues or damages surfaces.',
  },
  {
    title: 'Color-Coded Cloth System',
    description: 'Assign cloth colors to zones—red for bathrooms, blue for kitchen, green for general surfaces—to prevent cross-contamination.',
  },
  {
    title: 'Eco-Certification Awareness',
    description: 'Look for EU Ecolabel or Nordic Swan logos. Those products balance efficacy and environmental impact, and often outperform generic brands.',
  }
];

const ProductTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <CleaningServicesIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Cleaning Product Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Get the most out of your cleaning products with these expert tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all product tips
      </Button>
    </Box>
  </Box>
);

export default ProductTips; 